// src/components/learner/PortfolioItemCard.js
import React from 'react';
import { formatDate } from '../../utils/dateUtils';

const PortfolioItemCard = ({ assignment, submission, isSelected, onClick }) => {
  // Helper to truncate text if it's too long
  const truncateText = (text, maxLength = 80) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  // Determine submission status badge text
  const getStatusBadge = (status) => {
    if (status === 'reviewed') return 'Reviewed';
    if (status === 'updated') return 'Updated';
    if (status === 'submitted') return 'Submitted';
    return 'Completed';
  };

  // Parse date string to Date object if needed
  const parseDate = (dateValue) => {
    if (!dateValue) return null;
    if (dateValue instanceof Date) return dateValue;
    
    // Handle Firebase timestamp or string date
    if (typeof dateValue === 'string') {
      return new Date(dateValue);
    }
    
    // Handle Firebase timestamp object
    if (dateValue.toDate && typeof dateValue.toDate === 'function') {
      return dateValue.toDate();
    }
    
    return null;
  };

  // Format the date for display
  const formatDateString = (dateValue) => {
    const date = parseDate(dateValue);
    if (!date) return 'Unknown date';
    return formatDate(date, 'medium');
  };

  return (
    <div 
      className={`portfolio-item ${isSelected ? 'active' : ''}`}
      onClick={() => onClick({ assignment, submission })}
    >
      <h3>{assignment.title}</h3>
      
      {submission && (
        <>
          {submission.content && (
            <p className="submission-excerpt">
              {truncateText(submission.content)}
            </p>
          )}
          
          <div className="submission-meta">
            <span className={`status-badge ${submission.reviewStatus === 'reviewed' ? 'reviewed' : 'pending'}`}>
              {getStatusBadge(submission.reviewStatus)}
            </span>
            <span className="submission-date">
              {formatDateString(submission.updatedAt)}
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default PortfolioItemCard;